// import { createSelector } from 'reselect';

export const getIsPosting = state => state.getIn(['consultationFiles', 'isPosting']);
export const getIsPutting = state => state.getIn(['consultationFiles', 'isPutting']);
export const getIsDeleting = state => state.getIn(['consultationFiles', 'isDeleting']);
export const getErrMsg = state => state.getIn(['consultationFiles', 'errMsg']);